<span>
  {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.NOTIFICATION_TYPE_HINT' | translate }}
</span>
<span class="link" (click)="openNotificationSettings()">
  {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.NOTIFICATION_LINK' | translate }}
  <mat-icon class="inline-icon">open_in_new</mat-icon>
</span>
